export default "__VITE_ASSET__BR75_qCw__"